import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { UploadCloud } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const FileOutputNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'File Output'}
        icon={UploadCloud}
        colorClass="from-emerald-500 to-emerald-700"
        bgClass="bg-gradient-to-br from-emerald-500 to-emerald-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
FileOutputNode.displayName = 'FileOutputNode';
export default FileOutputNode;
